import images from 'assets/images';
import { Colors } from 'theme';

/**
 * This is a catalog label for DeviceStatus.
 */
export const DeviceStatusName = {
  Maintenance: 'Maintenance',
  Faulted: 'Fault',
  Alarm: 'Alarm',
  Warning: 'Warning',
  Ok: 'OK',
  Disconnected: 'Disconnected',
};

/**
 * This is a catalog for Device Status Ids.
 */
export const DeviceStatusId = {
  All: 0,
  Maintenance: 1,
  Faulted: 2,
  Alarm: 3,
  Warning: 4,
  Ok: 5,
  Disconnected: 6,
};

const DeviceStatusIds = Object.values(DeviceStatusId).filter(
  (statusId) => statusId !== DeviceStatusId.All,
);
const DeviceStatusSeverityRank = [
  DeviceStatusId.Maintenance,
  DeviceStatusId.Faulted,
  DeviceStatusId.Alarm,
  DeviceStatusId.Warning,
  DeviceStatusId.Disconnected,
  DeviceStatusId.Ok,
].reduce((rankMap, statusId, index) => ({ ...rankMap, [statusId]: index }), {});

export const normalizeDeviceStatusId = (statusId) => {
  const normalizedStatusId = Number(statusId);

  return Number.isFinite(normalizedStatusId) && DeviceStatusIds.includes(normalizedStatusId)
    ? normalizedStatusId
    : null;
};

export const getMostSevereDeviceStatusId = (statusIds = []) =>
  (Array.isArray(statusIds) ? statusIds : [])
    .map(normalizeDeviceStatusId)
    .filter((statusId) => statusId !== null)
    .reduce((mostSevereStatusId, statusId) => {
      if (mostSevereStatusId === null) return statusId;

      const mostSevereRank =
        DeviceStatusSeverityRank[mostSevereStatusId] ?? Number.MAX_SAFE_INTEGER;
      const statusRank = DeviceStatusSeverityRank[statusId] ?? Number.MAX_SAFE_INTEGER;

      return statusRank < mostSevereRank ? statusId : mostSevereStatusId;
    }, null);

export const getDevicesStatusId = (devices = []) =>
  getMostSevereDeviceStatusId(
    (Array.isArray(devices) ? devices : []).map((device) => device?.statusId),
  );

/**
 * This is a catalog to render Device Status Options.
 */
export const DeviceStatus = [
  {
    icon: images.iconMaintenance,
    name: DeviceStatusName.Maintenance,
    id: DeviceStatusId.Maintenance,
    backgroundColor: Colors.alizarinCrimson,
  },
  {
    icon: images.iconFaulted,
    name: DeviceStatusName.Faulted,
    id: DeviceStatusId.Faulted,
    backgroundColor: Colors.flameaPea,
  },
  {
    icon: images.iconAlarm,
    name: DeviceStatusName.Alarm,
    id: DeviceStatusId.Alarm,
    backgroundColor: Colors.christine,
  },
  {
    icon: images.iconWarning,
    name: DeviceStatusName.Warning,
    id: DeviceStatusId.Warning,
    backgroundColor: Colors.goldenDream,
  },
  {
    icon: images.iconOk,
    name: DeviceStatusName.Ok,
    id: DeviceStatusId.Ok,
    backgroundColor: Colors.olivine,
  },
  {
    icon: images.iconWifiDisconnected,
    name: DeviceStatusName.Disconnected,
    id: DeviceStatusId.Disconnected,
    backgroundColor: Colors.white,
  },
];
